module.exports = __webpack_public_path__ + "img/moniter-02@2x.f647f592.png";